import RichTextEditor from 'react-rte'

const memoDefaultOptions = {
  value: RichTextEditor.createEmptyValue(),
  column: '1/1',
}

export default memoDefaultOptions
